import * as React from 'react';
import { useEffect, useState } from 'react';
import ReactDataGrid from 'react-data-grid';
import { Property } from '../../../../../api/Property';
import '../../../../../styles/PropertiesPage.css';

export interface Props {
    properties: Property[];
    setSelectedProperty: (property: Property) => void;
}

export enum PropertyGridColumns {
    Name = 'name',
    City = 'city',
    State = 'state'
}

const sortRows = (
    initialRows: Property[],
    sortColumn: PropertyGridColumns,
    sortDirection: 'ASC' | 'DESC' | 'NONE'
) => (rows: Property[]) => {
    const comparer = (a: Property, b: Property) => {
        if (sortDirection === 'ASC') {
            return a[sortColumn].toLowerCase() > b[sortColumn].toLowerCase() ? 1 : -1;
        } else if (sortDirection === 'DESC') {
            return a[sortColumn].toLowerCase() < b[sortColumn].toLowerCase() ? 1 : -1;
        }
        return 0;
    };
    return sortDirection === 'NONE' ? initialRows : [...rows].sort(comparer);
};

const ListView = (props: Props) => {
    const [rows, setRows] = useState(props.properties);
    useEffect(() => {
        setRows(props.properties);
    }, [props.properties]);
    useEffect(() => {
        sortRows(props.properties, PropertyGridColumns.Name, 'ASC');
    });

    return (
        <div className="list-view">
            <ReactDataGrid
                columns={[
                    {
                        key: 'name',
                        name: 'Property',
                        resizable: true,
                        sortable: true,
                        cellClass: 'property-links'
                    },
                    {
                        key: 'city',
                        name: 'City',
                        resizable: true,
                        sortable: true
                    },
                    {
                        key: 'state',
                        name: 'State',
                        resizable: true,
                        sortable: true
                    }
                ]}
                headerRowHeight={30}
                rowHeight={60}
                enableCellSelect={false}
                rowGetter={i => i === rows.length ? {} : rows[i]}
                rowsCount={rows.length + 1}
                onRowClick={(_rowIdx: number, row: Property) => {
                    if (_rowIdx >= 0) {
                        props.setSelectedProperty(row);
                    }
                }}
                onGridSort={(sortColumn: PropertyGridColumns, sortDirection) =>
                    setRows(sortRows(props.properties, sortColumn, sortDirection))
                }
                sortColumn={'name'}
                sortDirection={'ASC'}
            />
        </div>
    );
};

export default ListView;



// WEBPACK FOOTER //
// ./src/components/pages/prospect/public/properties/ListView.tsx